module.exports = __webpack_public_path__ + "static/media/sidemenu-expand-icon.a01f8727.svg";